import React, {useEffect} from 'react';
import GaurabdaCalendar from "./components/gcalendar";
import FullYearCalendar from "./pages/yearcalendar";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import './language/config';
import AstrologicalDiary from "./pages/astrologicalDiary";
import Login from "./pages/login";
import {useTypedSelector} from "./hook/useTypedSelector";
import NotFoundPage from "./pages/notFound";
import EkadashiList from "./pages/ekadashiList";
import {AddPageReloadAsync, GetUIDAsync} from "./services/api-statistic-service";
import NavLabel from "./components/nav-label";
import Register from "./pages/register";
import PageInDevelopment from "./pages/pageInDevelopment";
import Confirmation from "./pages/register/confirmation";
import Profile, {ProfileDropdowns} from "./pages/profile";
import "./styles.css"
import PostResult from "./components/post-result";
import HelpList from "./components/help-list";
import AllUsers from "./pages/admin/allUsers";
import AddUser from "./pages/admin/addUser";
import EditUser from "./pages/admin/editUser";
import AllGroups from "./pages/admin/allGroups";
import EditGroup from "./pages/admin/editGroup";
import AdminPanel from "./pages/admin";
import AllReports from "./pages/admin/allReports";
import EkadashiListV2 from "./pages/ekadashiListV2";
import Redirect from "./pages/Redirect";
import AdminPanelLayout from "./pages/admin/adminPanelLayout";

function App() {
    const {isAuth, user} = useTypedSelector((store) => store.user);

    useEffect(() => {
        const handleBeforeUnload = async () => {
            const uid = localStorage.getItem("uid");
            if (uid) {
                await AddPageReloadAsync(uid);
            } else {
                const {response} = await GetUIDAsync()
                localStorage.setItem("uid", response);
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<NavLabel/>}>
                    <Route path="/" element={<Profile preOpenDropdown={ProfileDropdowns.GCAL}/>}/>
                    <Route path="/astrological-diary" element={<AstrologicalDiary/>}/>
                    <Route path="/redirect" element={<Redirect/>}/>

                    {!isAuth && (
                        <>
                            <Route path="/login" element={<Login/>}/>
                            <Route path="/register" element={<Register/>}/>
                            <Route path="/confirm-email" element={<Confirmation/>}/>

                            <Route path="/profile" element={<Navigate to={"/login"}/>}/>
                            <Route path="/report" element={<Navigate to={"/login"}/>}/>
                            <Route path="/results" element={<Navigate to={"/login"}/>}/>
                            <Route path="/help-list" element={<Navigate to={"/login"}/>}/>
                            <Route path="/full-year-calendar" element={<Navigate to={"/login"}/>}/>
                        </>
                    )}


                    {isAuth && (
                        <>
                            <Route path="/login" element={<Navigate to={"/"}/>}/>
                            <Route path="/register" element={<Navigate to={"/"}/>}/>
                            <Route path={"/profile"} element={<Profile preOpenDropdown={ProfileDropdowns.PROFILE}/>}/>
                            <Route path="/report" element={<Profile preOpenDropdown={ProfileDropdowns.REPORT}/>}/>
                            <Route path="/results" element={<Profile preOpenDropdown={ProfileDropdowns.RESULTS}/>}/>
                            <Route path="/help-list" element={<Profile preOpenDropdown={ProfileDropdowns.HELP_LIST}/>}/>
                            <Route path="/full-year-calendar" element={<FullYearCalendar/>}/>
                        </>
                    )}
                </Route>

                {
                    user && user.role && user.role.includes("Admin") &&
                    <Route element={<AdminPanelLayout/>}>
                        <Route path="/admin">
                            <Route index element={<AdminPanel/>}/>

                            <Route path="users" element={<AllUsers/>}/>
                            <Route path="add-user" element={<AddUser/>}/>
                            <Route path="edit-user" element={<EditUser/>}/>

                            <Route path="groups" element={<AllGroups/>}/>
                            <Route path="edit-group" element={<EditGroup/>}/>

                            <Route path="reports" element={<AllReports/>}/>
                        </Route>
                    </Route>
                }

                <Route path="/philosophy" element={<PageInDevelopment/>}/>
                <Route path="/education" element={<PageInDevelopment/>}/>
                <Route path="/information" element={<PageInDevelopment/>}/>

                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;